import { apiGet, apiPost } from './index'

export type FeatureSeatSummary = {
  base: number
  addon: number
  total: number
  assigned: number
  available: number
}

export type SeatSummary = {
  inbox: FeatureSeatSummary
  prep: FeatureSeatSummary
}

export type StationMember = {
  user_id: number
  display_name: string
  email: string
  role: string
  status: string
  assigned_seat: number
  joined_at: string | null
}

export type StationMembersResponse = {
  members: StationMember[]
  seats: SeatSummary
  subscription_active: boolean
}

export type StationInvite = {
  id: number
  email: string
  status: string
  expires_at: string | null
  created_at: string | null
  accepted_at: string | null
}

export type StationInvitesResponse = {
  invites: StationInvite[]
}

export type StationRequest = {
  id: number
  user_id: number
  status: string
  requested_at: string
  decided_at: string | null
  display_name: string
  email: string
}

export type StationRequestsResponse = {
  requests: StationRequest[]
}

export type FeatureDeny = {
  user_id: number
  feature_key: string
  denied_by_user_id: number
  denied_at: string
  note: string | null
}

export type FeatureDeniesResponse = {
  denies: FeatureDeny[]
}

export type CreateInviteResponse = {
  token: string
  expires_at: string | null
  station_id: number
  subscription_active: boolean
}

export function getStationMembers(stationId: number): Promise<StationMembersResponse> {
  return apiGet<StationMembersResponse>(`stations/${stationId}/members`)
}

export function getStationInvites(stationId: number): Promise<StationInvitesResponse> {
  return apiGet<StationInvitesResponse>(`stations/${stationId}/invites`)
}

export function createStationInvite(stationId: number, email?: string): Promise<CreateInviteResponse> {
  return apiPost<CreateInviteResponse>(`stations/${stationId}/invites`, {
    station_id: stationId,
    email: email ?? '',
  })
}

export function getStationRequests(stationId: number): Promise<StationRequestsResponse> {
  return apiGet<StationRequestsResponse>(`stations/${stationId}/requests`)
}

export function approveStationRequest(stationId: number, requestId: number): Promise<{ id: number; status: string }> {
  return apiPost<{ id: number; status: string }>(`stations/${stationId}/requests/${requestId}/approve`, {
    station_id: stationId,
    request_id: requestId,
  })
}

export function rejectStationRequest(stationId: number, requestId: number): Promise<{ id: number; status: string }> {
  return apiPost<{ id: number; status: string }>(`stations/${stationId}/requests/${requestId}/reject`, {
    station_id: stationId,
    request_id: requestId,
  })
}

export function getFeatureDenies(stationId: number): Promise<FeatureDeniesResponse> {
  return apiGet<FeatureDeniesResponse>(`stations/${stationId}/denies`)
}

export function setFeatureDeny(
  stationId: number,
  userId: number,
  featureKey: string,
  denied: boolean,
): Promise<{ station_id: number; user_id: number; feature_key: string; denied: boolean }> {
  return apiPost<{ station_id: number; user_id: number; feature_key: string; denied: boolean }>(
    `stations/${stationId}/denies`,
    {
      station_id: stationId,
      user_id: userId,
      feature_key: featureKey,
      denied,
    },
  )
}
